
export class UserMessageService {
    constructor() {
        this.userMessageCallback = {};
        this.userErrorCallback = {};
        this.userWarningCallback = {};

    }




    setUserMessageCallback(name, callback) {
      // debugger;
        this.userMessageCallback[name] = callback;
    }

    setUserErrorCallback(name, callback) {
      // debugger;
        this.userErrorCallback[name] = callback;
    }

    setUserWarningCallback(name, callback) {
      this.userWarningCallback[name] = callback;
    }
    setUserMessage(name, text) {

            this.userMessageCallback[name](text);

    }

    setUserError(name, text) {

        this.userErrorCallback[name](text);

    }

    setUserWarning(name, text) {
      this.userWarningCallback[name](text);
    }



}
